import { apiClient } from '../api-client';
import { COMMENTS } from '../../api-endpoints/api-endpoints';
import { ApiComment, CreateCommentInput, ListCommentsResponse } from '../../schema/comments/comment.schema';

export const commentsService = {
  list: (ticketId: string, includeInternal = false): Promise<ListCommentsResponse> =>
    apiClient.get<ListCommentsResponse>(
      `${COMMENTS.list(ticketId)}?includeInternal=${includeInternal}`,
    ),

  create: (ticketId: string, body: CreateCommentInput): Promise<ApiComment> =>
    apiClient.post<ApiComment>(COMMENTS.create(ticketId), body),

  update: (id: string, body: string): Promise<ApiComment> =>
    apiClient.patch<ApiComment>(COMMENTS.update(id), { body }),

  remove: (id: string): Promise<{ deleted: boolean }> =>
    apiClient.delete<{ deleted: boolean }>(COMMENTS.remove(id)),
};
